import { SrpPaymentCalculator } from '../components/srp/srp-payment-calculator.vue';
Vue.component('srp-payment-calculator', SrpPaymentCalculator);